import type { PatientSubmittingAction } from '../hooks/usePatientEditPage.types';

interface BulkHistoryButtonState {
  loading: boolean;
  disabled: boolean;
}

export function getBulkHistoryButtonState(
  isSubmitting: boolean,
  submittingAction: PatientSubmittingAction | null
): BulkHistoryButtonState {
  return {
    loading: false,
    disabled: isSubmitting && submittingAction !== null,
  };
}
